import { ComponentType, LinkType } from "interfaces/content";
import Link from "ui/Link";
import { getStringWithLineBreak } from "utils/parse";

export const getComponentDynamically = async (
  object?: ComponentType,
): Promise<React.ComponentType | undefined> => {
  if (!object) return undefined;

  if (object?.path) {
    const module = await import(`domain/public/Content/components/${object.path}`);

    if (!module?.default) {
      return;
    }

    return module.default;
  }
};

export const handleTextAndLinkType = (value: LinkType | string, blank = true) => {
  if (typeof value === "string") {
    return getStringWithLineBreak(value);
  }

  return (
    <Link href={value.href} target={`${blank ? "_blank" : ""}`}>
      {value.text}
    </Link>
  );
};
